const styles = {
  archiveButton: {
    fontSize: 12,
    width: 20,
    height: 20,
    position: "absolute",
    top: 5,
    right: 5,
  },
  text: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    WebkitLineClamp: 1,
    textOverflow: "ellipsis",
    fontSize: 12,
  },
};

export default styles;
